import { useApi } from '@backstage/core-plugin-api';
import { announcementsApiRef } from '../apis';
import { AnnouncementStatus } from '@internal/backstage-plugin-announcements-common';
import useAsyncRetry from 'react-use/esm/useAsyncRetry';

/**
 * Hook to get all categories.
 *
 * @returns a list of all categories
 *
 * @public
 */
export const useAnnouncementReadStatus = (): {
  value: AnnouncementStatus;
  loading: boolean;
  error: Error | undefined;
  retry: () => void;
} => {
  const api = useApi(announcementsApiRef);
  const { loading, error, value, retry } = useAsyncRetry(
    async () => await api.getStatus(),
  );
  return {
    value: value ?? { read: 0, unread: 0, totalUnread: 0 },
    loading,
    error,
    retry,
  };
};
